var exports = {
  "kL": "xa15a2ab7--abe13e--container",
  "kb": "xa15a2ab7--abe13e--left",
  "DD": "xa15a2ab7--abe13e--title",
  "s6": "xa15a2ab7--abe13e--agent-name",
  "g_": "xa15a2ab7--abe13e--proofs",
  "Uo": "xa15a2ab7--abe13e--buttons",
  "x6": "xa15a2ab7--abe13e--button",
  "my": "xa15a2ab7--abe13e--avatar",
  "D9": "xa15a2ab7--abe13e--phones-opened-info",
  "o3": "xa15a2ab7--abe13e--super-agent",
};

module.exports = exports;
